const isGroupedOptin = (item) => "groupedOptIns" in item;
var FormName = /* @__PURE__ */ ((FormName2) => {
  FormName2["personalDetails"] = "personalDetails";
  FormName2["billingAddress"] = "billingAddress";
  FormName2["preferredStore"] = "preferredStore";
  FormName2["signUp"] = "signUp";
  return FormName2;
})(FormName || {});
export {
  FormName,
  isGroupedOptin
};
//# sourceMappingURL=types.js.map
